
import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import styled from 'styled-components';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

import {
    getColor,
    getFontFamily,
    getFontSize,
    getLetterSpacing,
    getLineHeight,
} from '@process-advisor/process-miner/shared/theme';

const RadioComponent = styled(Radio)<{ checked?: boolean }>`
    color: ${({ checked }) =>
        checked
            ? getColor('lightBlue')
            : getColor('lightBorderColor')};
    height: 25px;
    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;

const StyledFormControlLabel = styled(FormControlLabel)`
    margin-right: 15px;
    height: 25px;

    & .MuiFormControlLabel-label {
        color: ${getColor('inputTextColor')};
        font-family: ${getFontFamily('atlassian')};
        font-size: ${getFontSize('smaller')};
        letter-spacing: ${getLetterSpacing('small')};
        line-height: ${getLineHeight('small')};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        
    }
`;
const Wrapper = styled.div`

`;
    
export const Highlight = () => {
    const [value, setValue] = React.useState('duration');
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        const highlight = (event.target as HTMLInputElement).value;
        setValue(highlight);
        apiProvider.changeHighlight({
            highlightLoops: highlight === 'loops',
            stepColourVolume: highlight === 'volume',
            stepColourDuration: highlight === 'duration',
            stepColourStdDeviation: highlight === 'std_deviation',

        });
        apiProvider.rebuildPVDiagram({});
    };

    React.useEffect(() => {
        const listener = () => { 
            setValue('compliance')
        };       
        apiProvider.on(Event.updateGaugeCompliance, listener);
        return () => {
            apiProvider.off(Event.updateGaugeCompliance, listener);
        };
    }, []);

    React.useEffect(() => {
        const listener = () => { 
            setValue('automation')
        };       
        apiProvider.on(Event.updateGaugeAutomation, listener);
        return () => {
            apiProvider.off(Event.updateGaugeAutomation, listener);
        };
    }, []);



    return (
        <Wrapper>
            <RadioGroup
                row
                aria-label="highlight"
                name="highlight"
                value={value}
                onChange={handleChange}>
                <StyledFormControlLabel
                    value="duration"
                    control={<RadioComponent />}
                    label="Duration" />
                <StyledFormControlLabel
                    value="volume"
                    control={<RadioComponent />}
                    label='Volume' />                    
                <StyledFormControlLabel
                    value="std_deviation"
                    control={<RadioComponent />}
                    label="Std Deviation" />
                <StyledFormControlLabel
                    value="loops"
                    control={<RadioComponent />}
                    label='Loops' />  
            </RadioGroup>
        </Wrapper>
    );
};
